import { CaseModel } from "@app/api2/api";
import { PageHeader } from "@common/PageHeader";
import { Link } from "react-router-dom";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { getLabFilter2 } from "@common/Utils";
import { queriesClient } from "@app/api2/Clients";
import { BPReactTable2, getFilterValue, useBpReactTable2 } from "../Common/DataTable/BPReactTable2";
import { ColumnDef } from "@tanstack/react-table";
import { isParameterTruthy } from "../CaseRun/ParameterField";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";
import { BPContainer } from "@/components/bp/bpcontainer";

interface CasesProps {
    canCreateCase: boolean;
}

export function Cases(props: CasesProps) {
    const columns: ColumnDef<CaseModel>[] = [
        getLabFilter2('labId', window.translation.common.labs),
        {
            meta: {
                width: "0px",
                Filter: (filter) => <BPCheckbox label={window.translation.case.hasQualityCheckProfiles} checked={filter.getFilterValue() as any} onChange={(e, { value, checked }) => filter.setFilterValue(checked)} />,
                hidden: true
            },
            header: '',
            id: 'hasQualityCheckProfiles',
            enableSorting: false,
        },
        {
            meta: {
                Filter: (filter) => <BPCheckbox label={window.translation.case.searchInSampleName} checked={filter.getFilterValue() as any} onChange={(e, { value, checked }) => filter.setFilterValue(checked)} />,
                hidden: true,
                width: "0px",
            },
            enableSorting: false,
            header: '',
            id: 'sampleSearch',
        },
        {
            header: window.translation.case.name,
            accessorKey: 'name',
            // Cell: cell => <a href={cell.row.original.url}>{cell.value}</a>,
            cell: cell => (
                // <Link to={`/lab/${cell.row.original.labId}/case/${cell.row.original.id}`}>{cell.value}</Link>
                <Link to={buildUrl(AppRoutes.CaseDetails, { caseId: cell.row.original.id.toString(), labId: cell.row.original.labId.toString() })}>{cell.getValue<string>()}</Link>
            ),
            meta: {
                tableCellProps: { width: 5 }
            }
        },
        {
            header: window.translation.common.lab,
            accessorKey: 'labName',
            meta: {
                tableCellProps: { width: 5 },
            }
        },
        {
            header: window.translation.common.agency,
            accessorKey: 'agencyName',
            meta: {
                tableCellProps: { width: 5 },
            }
        },

    ];
    const query = useBpReactTable2({
        queryKeyPrefix: 'Cases',
        defaultSortingState: [{ id: 'name', desc: false }],
        columnDefs: columns,
        query: async (paging, sorting, searchValue, filters) => {
            let sampleSearch = isParameterTruthy(getFilterValue(filters, 'sampleSearch'))
            let hasQualityCheckProfiles = isParameterTruthy(getFilterValue(filters, 'hasQualityCheckProfiles'))
            let labId = parseInt(getFilterValue(filters, 'labId')) ?? null
            if (labId == -1 || isNaN(labId))
                labId = null;

            // console.log(sampleSearch)
            let pageData = await queriesClient.getCases(paging.pageSize, paging.pageIndex, sorting[0]?.id, sorting[0]?.desc ? "desc" : "asc", searchValue, sampleSearch, hasQualityCheckProfiles, labId);
            return { rows: pageData.items, rowCount: pageData.totalRows };
        }
    });

    return <BPContainer>
        <PageHeader header={window.translation.common.cases}
            renderRight={() =>
            (props.canCreateCase &&
                <BPButton as={Link} to={buildUrl(AppRoutes.CaseCreate, {})}>{window.translation.caseView.create}</BPButton>
            )} />
        <BPReactTable2 {...query}></BPReactTable2>
    </BPContainer>
}

